import { adjustPaddingTop } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
	const linkElements = document.querySelectorAll(
		'.mainmenu-ancestorlink.mainmenu-dropdownlink'
	);

	linkElements.forEach((linkElement) => {
		const parentElement = linkElement.parentElement;
		parentElement.addEventListener('mouseover', () =>
			document.body.classList.add('menu-hover')
		);
		parentElement.addEventListener('mouseout', () =>
			document.body.classList.remove('menu-hover')
		);
	});

	setTimeout(() => {
		adjustPaddingTop();
	}, 200);

	window.addEventListener('resize', adjustPaddingTop);
});
